"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createProxy = exports.create = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _axios = _interopRequireDefault(require("axios"));

var _envUtils = require("./env-utils");

var _permissions = require("./permissions");

var _configs = require("./configs");

var createConfig = function createConfig(env, oktaTokenDomain, isDevelopment) {
  return (0, _extends2["default"])({}, (0, _configs.airbnb)(env), (0, _configs.featureToggle)(env), (0, _configs.general)(env, oktaTokenDomain, isDevelopment), (0, _configs.overrides)(env));
};

var buildURL = function buildURL(_ref) {
  var version = _ref.version,
      domain = _ref.domain,
      isPublic = _ref.isPublic,
      config = _ref.config;

  if (isPublic && !domain) {
    console.warn('Error while creating Resource. No domain supplied to isPublic, reverting to api/v2');
  }

  var API_GATEWAY = config.API_GATEWAY,
      API_GATEWAY_PUBLIC = config.API_GATEWAY_PUBLIC,
      PROXY_URL = config.PROXY_URL,
      MAILER_URL = config.MAILER_URL;

  if (version === 'v3') {
    var gateway = isPublic ? API_GATEWAY_PUBLIC : API_GATEWAY;

    if (domain[0] === '/') {
      return "".concat(gateway).concat(domain);
    }

    return "".concat(gateway, "/").concat(domain);
  }

  if (version === 'proxy') {
    return PROXY_URL;
  }

  return MAILER_URL;
};

var getVersion = function getVersion(options) {
  var domain = options.domain;

  if (typeof options === 'string' || domain) {
    return 'v3';
  }

  return 'mailer';
};

var baseURLForOptions = function baseURLForOptions(options) {
  var baseURL = options.baseURL,
      version = options.version,
      domain = options.domain,
      isPublic = options.isPublic,
      config = options.config;
  return baseURL || buildURL({
    version: version,
    domain: domain,
    isPublic: isPublic,
    config: config
  });
};

var defaultOptions = {
  version: 'mailer',
  domain: undefined,
  isPublic: false,
  tokenKey: null,
  tokenFunc: null,
  intercept401: true
};

var create = function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultOptions;
  var token = options.token || (0, _envUtils.getToken)(options);

  var _parseToken = (0, _envUtils.parseToken)(token),
      parsedEnv = _parseToken.parsedEnv,
      userRoles = _parseToken.userRoles,
      oktaTokenDomain = _parseToken.oktaTokenDomain;

  var tokenFunc = options.tokenFunc,
      intercept401 = options.intercept401;
  var env = options.env || parsedEnv || 'staging';
  var version = options.version || getVersion(options);
  var development = options.development || ['localhost', '0.0.0.0', 'host.docker.internal'].includes(window.location.hostname);
  var config = createConfig(env, oktaTokenDomain, development);
  var urlOptions = typeof options === 'string' ? {
    domain: options
  } : options;
  var baseURL = baseURLForOptions((0, _extends2["default"])({}, urlOptions, {
    config: config,
    version: version,
    env: env
  }));
  var axiosOptions = typeof options === 'string' ? undefined : options;

  var http = _axios["default"].create(axiosOptions);

  http.defaults.baseURL = baseURL;
  http.defaults.headers.common['X-agni-version'] = '2';
  http.defaults.headers.common.Authorization = "Bearer ".concat(token);
  http.defaults.headers.post['Content-Type'] = 'application/json';
  http.defaults.headers.put['Content-Type'] = 'application/json';
  http.defaults.headers.patch['Content-Type'] = 'application/json';
  http.interceptors.request.use( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(currentRequestConfig) {
      var bearerToken;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              bearerToken = tokenFunc ? tokenFunc() : options.token || (0, _envUtils.getToken)(options); // eslint-disable-next-line no-param-reassign

              currentRequestConfig.headers = (0, _extends2["default"])({}, currentRequestConfig.headers, {
                Authorization: "Bearer ".concat(bearerToken)
              });
              return _context.abrupt("return", currentRequestConfig);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), function (error) {
    Promise.reject(error);
  });

  if (intercept401) {
    http.interceptors.response.use(function (response) {
      return response;
    }, function (error) {
      var _error$response = error.response;
      _error$response = _error$response === void 0 ? {} : _error$response;
      var status = _error$response.status;

      if (status === 401) {
        var _window, _window$location;

        window.location.replace("/auth/logout?ref=".concat(encodeURIComponent((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href)));
      }

      return Promise.reject(error);
    });
  }

  http.withInstanceContext = function (params) {
    var http2 = http.create();
    http2.defaults.headers.common['x-org-instance-ctx'] = params;
    return http2;
  };

  var roles = (0, _permissions.createRoles)(userRoles);
  return {
    config: config,
    env: env,
    development: development,
    version: version,
    api: http,
    roles: roles
  };
};

exports.create = create;

var createProxy = function createProxy(options) {
  var newOptions = (0, _extends2["default"])({}, options, {
    version: 'proxy'
  });
  return create(newOptions);
};

exports.createProxy = createProxy;
var _default = {
  create: create,
  createProxy: createProxy
};
exports["default"] = _default;